import React, {useEffect, useState} from 'react';
import {StyleSheet, Platform, ScrollView, View, Text} from 'react-native';
import {useForm, Controller} from 'react-hook-form';
import TextInput from '../../components/TextInput';
import Error from '../../components/Error';
import Button from '../../components/Button';
import SelectInput from '../../components/SelectInput';
import {calculPAT} from './calcul';
import {isNotDefaultSelect, isPositiveNumber} from '../../utils';
import {getSelectPatentes, localProData, getSelectCommunes} from './data';
import {communes_fiscalesData as communes} from '../FormIF/data';
import {getPatentes} from '../../api/SimuPAT';
import patentesData from './patentes';

const FormPAT = ({
  jumpTo,
  setValeurDF,
  setValeurDP,
  setValeurCAC,
  setValeurCHC,
  setValeurTVLLP,
  setValeurTA,
  setResult,
}) => {
  const [patentes, setPatentes] = useState(patentesData);

  const {register, handleSubmit, control, errors, watch} = useForm({
    mode: 'onChange',
    defaultValues: {
      activite: 'Acconier',
      commune: communes[0].name,
      nbSalaries: 0,
      localPro: false,
      loyerAnnuel: 0,
      loyerMateriel: 0,
      valeurEV1: 0,
      valeurEV2: 0,
      valeurEV3: 0,
      valeurEV4: 0,
      valeurEV5: 0,
      valeurEV6: 0,
    },
  });

  const localPro = watch('localPro');
  const activite = watch('activite');
  const loyerAnnuel = watch('loyerAnnuel');
  const loyerMateriel = watch('loyerMateriel');

  const onSubmit = (values) => {
    const total = calculPAT(values, patentes, communes);
    console.log(total);
    setValeurDF(total.valeurDF);
    setValeurDP(total.valeurDP);
    setValeurCAC(total.valeurCAC);
    setValeurCHC(total.valeurCHC);
    setValeurTVLLP(total.valeurTVLLP);
    setValeurTA(total.valeurTA);
    setResult(total.result);
    jumpTo ? jumpTo('second') : '';
  };

  useEffect(() => {
    register('activite', {
      required: true,
      validate: (value) => isNotDefaultSelect(value),
    });

    register('commune', {
      required: true,
      validate: (value) => isNotDefaultSelect(value),
    });

    register('nbSalaries', {
      required: true,
      validate: (value) => isPositiveNumber(value),
    });

    register('localPro', {
      required: true,
      validate: (value) => isNotDefaultSelect(value),
    });

    register('loyerAnnuel');
    register('loyerMateriel');
    register('valeurEV1');
    register('valeurEV2');
    register('valeurEV3');
    register('valeurEV4');
    register('valeurEV5');
    register('valeurEV6');
  }, [register]);

  // useEffect(() => {
  //   getPatentes().then((data) => {
  //     setPatentes(data);
  //   });
  // }, []);

  const getElementVariables = (activite) => {
    const patente = patentes.find((data) => data.nomActivite == activite);
    const nbElementVariable = patente.nbElementVariable;
    let elements = [];
    for (let i = 1; i <= nbElementVariable; i++) {
      elements.push({
        name: `valeurEV${i}`,
        libelle: patente[`libelleElementVariable${i}`],
        multiplicateur: patente[`multiplicateur${i}`],
        minitv: patente[`minimumTaxeVariable${i}`],
        indictdecla: patente[`indicateurDeclarationAnnuelle${i}`],
        plancher: patente[`plancherEv${i}`],
      });
    }
    return elements;
  };

  const isIndust = (activite) => {
    const patente = patentes.find((data) => data.nomActivite == activite);
    return patente.indust === 'O';
  };

  const registerElementVariables = (activite) => {
    const elementVariables = getElementVariables(activite);
    const formElementVariables = elementVariables.map((element) => {
      return (
        <>
          <Controller
            control={control}
            name={element.name}
            key={element.name}
            render={(props) => (
              <TextInput
                onChangeText={props.onChange}
                value={props.value}
                label={element.libelle}
                placeholder="Veuillez entrer une valeur"
                keyboardType={Platform.OS === 'ios' ? 'number-pad' : 'numeric'}
              />
            )}
            rules={{
              required: true,
              validate: (value) => isPositiveNumber(value),
            }}
          />
          {errors[element.name]?.type === 'required' && (
            <Error>Ce champ est obligatoire !</Error>
          )}

          {errors[element.name]?.type === 'validate' && (
            <Error>Ce champ doit être un entier positif !</Error>
          )}
        </>
      );
    });

    return formElementVariables;
  };

  if (patentes.length <= 0) {
    return (
      <View>
        <Text>Chargement...</Text>
      </View>
    );
  }

  return (
    <ScrollView>
      <Controller
        control={control}
        name="activite"
        render={(props) => (
          <SelectInput
            selectedValue={props.value}
            onValueChange={props.onChange}
            noDefaultValue={true}
            label="Séléctionner votre activité"
            data={getSelectPatentes(patentesData)}
          />
        )}
      />

      {errors.activite?.type === 'required' && (
        <Error>Ce champ est obligatoire !</Error>
      )}

      {errors.activite?.type === 'validate' && (
        <Error>Veuillez choisir une valeur !</Error>
      )}

      <Controller
        control={control}
        name="commune"
        render={(props) => (
          <SelectInput
            selectedValue={props.value}
            onValueChange={props.onChange}
            label="Séléctionner votre commune fiscale"
            data={getSelectCommunes(communes)}
          />
        )}
      />

      {errors.commune?.type === 'required' && (
        <Error>Ce champ est obligatoire !</Error>
      )}

      {errors.commune?.type === 'validate' && (
        <Error>Veuillez choisir une valeur !</Error>
      )}

      <Controller
        control={control}
        name="nbSalaries"
        render={(props) => (
          <TextInput
            onChangeText={props.onChange}
            value={props.value}
            label="Nombre de salarié"
            placeholder="Veuillez entrer une valeur"
            keyboardType={Platform.OS === 'ios' ? 'number-pad' : 'numeric'}
          />
        )}
      />

      {errors.nbSalaries?.type === 'required' && (
        <Error>Ce champ est obligatoire !</Error>
      )}

      {errors.nbSalaries?.type === 'validate' && (
        <Error>Ce champ doit être un entier positif !</Error>
      )}

      <Controller
        control={control}
        name="localPro"
        render={(props) => (
          <SelectInput
            selectedValue={props.value}
            onValueChange={props.onChange}
            label="Activité avec local professionnel"
            data={localProData}
          />
        )}
      />

      {errors.localPro?.type === 'required' && (
        <Error>Ce champ est obligatoire !</Error>
      )}

      {errors.localPro?.type === 'validate' && (
        <Error>Veuillez choisir une valeur !</Error>
      )}

      {localPro === 'true' && (
        <>
          <Controller
            control={control}
            name="loyerAnnuel"
            render={(props) => (
              <TextInput
                onChangeText={props.onChange}
                value={props.value}
                label={`Valeur locative annuelle des locaux professionnels : ${loyerAnnuel}`}
                keyboardType={Platform.OS === 'ios' ? 'number-pad' : 'numeric'}
              />
            )}
            rules={{
              required: true,
              valueAsNumber: true,
              validate: (value) => isPositiveNumber(value),
            }}
          />

          {errors.loyerAnnuel?.type === 'required' && (
            <Error>Ce champ est obligatoire !</Error>
          )}

          {errors.loyerAnnuel?.type === 'validate' && (
            <Error>Ce champ doit être un entier positif !</Error>
          )}
        </>
      )}

      {isIndust(activite) && (
        <>
          <Controller
            control={control}
            name="loyerMateriel"
            render={(props) => (
              <TextInput
                onChangeText={props.onChange}
                value={props.value}
                label={`Valeur locative annuelle des moyens de production : ${loyerMateriel}`}
                keyboardType={Platform.OS === 'ios' ? 'number-pad' : 'numeric'}
              />
            )}
            rules={{
              required: true,
              valueAsNumber: true,
              validate: (value) => isPositiveNumber(value),
            }}
          />

          {errors.loyerMateriel?.type === 'required' && (
            <Error>Ce champ est obligatoire !</Error>
          )}
          {errors.loyerMateriel?.type === 'validate' && (
            <Error>Ce champ doit être un entier positif !</Error>
          )}
        </>
      )}

      {activite && registerElementVariables(activite)}

      <Button onPress={handleSubmit(onSubmit)} label="Faire la simulation" />
    </ScrollView>
  );
};

const styles = StyleSheet.create({});

export default FormPAT;
